import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-mobile-loans-landing',
    templateUrl: './loans-landing.component.html',
    styleUrls: ['../../layout/mobile.css', '../../layout/layout.component.scss']
})
export class MobileLoansLandingComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) { }
    public ngOnInit() {

    }

    public navigateList() {
        this.router.navigate([`mobile/loans/list`]);
    }

    public navigateDetails() {
        this.router.navigate([`mobile/loans/preview`]);
    }

    public navigateCreateNew() {
        this.router.navigate([`mobile/loans/create`]);
    }

    public navigateReturn() {
        this.router.navigate([`mobile/loans/return`]);
    }


}



// WEBPACK FOOTER //
// ./src/app/components/mobile/loans/loans-landing.component.ts